import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import firebase from "firebase/app";
import "firebase/messaging";
import NavBarContainer from "./NavBarContainer";
import { ReactComponent as ListView } from "./ListView.svg";
import { ReactComponent as SettingsIcon } from "./SettingsIcon.svg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faList, faBell } from "@fortawesome/free-solid-svg-icons";

const NavBar = props => {
  const { home } = props;
  return (
    <NavBarContainer home={home}>
      {firebase.messaging.isSupported() ? (
        <Link to="/settings" aria-label="Notifications Page">
          <SettingsIcon />
        </Link>
      ) : (
        <div />
      )}

      {!home && (
        <Link to="/" aria-label="Home Page">
          <ListView />
        </Link>
      )}
    </NavBarContainer>
  );
};

NavBar.propTypes = {
  home: PropTypes.bool
};

NavBar.defaultProps = {
  home: false
};

export default NavBar;
